import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";

const useDeleteRegion = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ id }: { id: string }) => {
            const response = await privateApi.delete(`/v4/region/${id}`);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['regions'] });
        }
    });
};

export default useDeleteRegion;
